module.exports = __webpack_public_path__ + "img/shot_bigtx8.305207fa.png";